<template>
    <div class="catalog-container" v-wechat-title="'mysread'">

        <vue-element-loading :active="isRequest" :is-full-screen="true" spinner="bar-fade-scale" color="#FF6700" />

        <!--頂部欄-->
        <div class="top-nav-container" style="position: fixed;top: 0">
            <span class="title-style">目錄</span>
            <span @click="backClick" style="position: absolute;left: 10px">返回</span>
            <span @click="reverseOrder" class="title-style" style="position: absolute;right: 10px">{{oderChapter}}</span>
        </div>

        <div class="catalog-content-container">

            <div v-for="chapter in chapterList">
                <span @click="startRead(chapter.chapterId)">{{chapter.title}}</span>
            </div>

        </div>

    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "CatalogVue",
    data() {
        return {
            isRequest: false,
            bookId: "",
            chapterList: [],
            oderChapter: "倒序",
            isReverse: false,
        };
    },
    methods: {
        //返回
        backClick: function () {
            this.$router.back();
        },

        //獲取書籍目錄
        getCatalogList: function () {
            this.isRequest = true;
            const params = new URLSearchParams();
            params.append("language", "zh-Hant");
            params.append("dev", "h5");
            params.append("uuid", "123456");
            params.append("ver", "1.0");
            params.append("ac", "getCatalogue");
            params.append("bookId", this.bookId);
            this.$http.post(axios.baseURL, params).then((res) => {
                this.isRequest = false;
                if (res.data.status) {
                    this.chapterList = res.data.data;
                } else {
                    alert(res.data.msg);
                }
            });
        },

        //倒序
        reverseOrder: function () {
            if (this.isReverse) {
                this.isReverse = false;
                this.oderChapter = "倒序";
            } else {
                this.isReverse = true;
                this.oderChapter = "正序";
            }
            this.chapterList = this.chapterList.reverse();
        },

        //開始閱讀
        startRead: function (chapterId) {
            this.$router.push({
                path: "ChapterDetailVue",
                query: {
                    bookId: this.bookId,
                    chapterId: chapterId,
                    bookName: this.bookName,
                },
            });
        },
    },
    created() {
        this.bookId = this.$route.query.bookId;
        this.bookName = this.$route.query.bookName;
        this.getCatalogList();
    },
};
</script>

<style scoped>
.catalog-container {
    max-width: 480px;
    min-height: calc(100vh);
    margin: 0 auto;
    border: 1px solid #cce9cb;
    background-color: #cce9cb;
}

.catalog-content-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-top: 60px;
    flex-wrap: wrap;
}

.catalog-content-container div {
    width: 45%;
    text-align: left;
    line-height: 30px;
    border-bottom: 1px solid darkgray;
    margin-left: 2%;
    margin-right: 2%;
}

.catalog-content-container div span {
    width: 90%;
    float: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
}

.catalog-content-container div :active {
    background-color: whitesmoke;
}
</style>



// WEBPACK FOOTER //
// src/components/CatalogVue.vue